var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Sidebar'),_c('div',{staticClass:"grid__body"},[_c('Header'),_c('main',{staticClass:"main"},[_c('router-view',{attrs:{"user":_vm.user}})],1),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }